// extracted by mini-css-extract-plugin
export default {"SideNavContainer":"SideNav_SideNavContainer__K5DBu","SideNavTab":"SideNav_SideNavTab__Ctac2"};